import React, { useState, useEffect, useRef } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const pathRef = useRef(null);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollY = window.pageYOffset;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      
      // Update visibility
      setIsVisible(scrollY > 300);
      
      // Calculate scroll progress (0 to 1)
      const progress = scrollHeight > 0 ? scrollY / scrollHeight : 0;
      setScrollProgress(Math.min(Math.max(progress, 0), 1));
    };

    window.addEventListener('scroll', toggleVisibility);
    // Initial calculation
    toggleVisibility();

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Calculate strokeDashoffset - ensure it's a valid number
  const circumference = 307.919; // 2 * PI * 49
  const dashOffset = circumference - (scrollProgress * circumference);
  const validDashOffset = isNaN(dashOffset) ? circumference : dashOffset;

  return (
    <div
      className="scroll-top"
      style={{
        display: isVisible ? 'flex' : 'none',
        cursor: 'pointer',
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        zIndex: 999,
        width: '50px',
        height: '50px',
        backgroundColor: '#153184',
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        transition: 'all 0.3s ease',
      }}
      onClick={scrollToTop}
    >
      <svg 
        className="progress-circle svg-content" 
        width="100%" 
        height="100%" 
        viewBox="-1 -1 102 102"
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <path
          ref={pathRef}
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          style={{
            transition: 'stroke-dashoffset 10ms linear 0s',
            strokeDasharray: circumference,
            strokeDashoffset: validDashOffset,
            stroke: '#ff6b35',
            strokeWidth: '3',
            fill: 'none',
          }}
        />
      </svg>
      <i 
        className="fas fa-arrow-up" 
        style={{ 
          color: 'white', 
          fontSize: '20px',
          position: 'relative',
          zIndex: 1
        }}
      ></i>
    </div>
  );
};

export default ScrollToTop;